import React from 'react';

import { Header as HeaderBase } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Link from 'components/link';
import { Box, BoxProps } from 'components/ui/box';
import { spacing } from 'styles/constants';

export const SectionContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.sectionContainer, style] });

export const Header = HeaderBase.withConfig({
  variant: 'headerOne',
  margin: 0,
  focusable: true,
});

export const HeaderLink = Link.withConfig({
  position: 'absolute',
  right: 0,
  bottom: 0,
  _text: {
    fontSize: 'sm',
    textTransform: 'capitalize',
  },
});

export const HeaderTextWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.headerTextWrapper, style] });

export const IconWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.iconWrapper, style] });

const styles = StyleSheet.create({
  sectionContainer: {
    marginBottom: spacing.$5,
    marginHorizontal: 'auto',
    minHeight: spacing.$4,
    paddingHorizontal: spacing.$4,
    paddingTop: spacing.$4,
    width: '100%',
  },
  headerTextWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: spacing.$2,
  },
  iconWrapper: {
    marginLeft: spacing.$2,
  },
});
